const clearMessage = messageEl => {
  messageEl.classList.add('hidden')
  messageEl.textContent = ''
}

const clearMessages = formEl =>
  formEl.querySelectorAll('[data-for-input]').forEach(clearMessage)

const renderErrors = (formEl, errors) => {
  const svgErrorIcon = '<svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" class="fill-ink"><path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" options=""></path></svg>'
  for (const [key, messages] of Object.entries(errors)) {
    const errorEl = formEl.querySelector(`[data-remote-message-key="${key}"]`)
    if (!errorEl) {
      continue
    }
    errorEl.innerHTML = svgErrorIcon + ' ' + messages[0]
    errorEl.classList.remove('hidden')
  }
}

const bindRemoteHandlers = formEl => {
  formEl.addEventListener('ajax:send', () => clearMessages(formEl))

  formEl.addEventListener('ajax:error', ({ detail: [data, _, xhr] }) => {
    if (xhr.status === 422) {
      renderErrors(formEl, data.errors)
    }
  })

  formEl.addEventListener('change', e => {
    const selector = `[data-for-input=${e.target.id}]`
    formEl.querySelectorAll(selector).forEach(clearMessages)
  })
}

const bindGatedContentHandler = formEl => {
  const { downloadUrl } = formEl.dataset

  if (!downloadUrl) {
    throw new Error(`form##{formEl.id} is missing data-download-url attribute.`)
  }

  formEl.addEventListener('ajax:success', () =>
    window.location.assign(downloadUrl),
  )
}

export {
  bindGatedContentHandler,
  bindRemoteHandlers,
  clearMessage,
  clearMessages,
  renderErrors,
}
